export const BACKEND_FLASH_MESSAGE_COOKIE_NAME = 'flash'
export const CLIENT_FLASH_MESSAGE_COOKIE_NAME = 'clientFlash'
